<div [className]="spinnerPosition === SpinnerPositionType.Fixed ? 'spinner-background-fixed' : 'spinner-background-absolute'">
    <div class="spinner-central">
        <div class="chat-spinner rotating spinner-image"></div>
    </div>
</div>